
import * as cdnProviderRuntime$WwPw9dOyBBJoAixmmH22q7hek9XFBqttHhtjTDBrtEA from '/home/vsts/work/1/s/src/providers/cdn-provider.ts'
import * as ipxRuntime$Yz6t6EezgLS0JjMNhtjX4WxsaC7Phwcm_eR5R3bdJEI from '/home/vsts/work/1/s/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['cdnProvider']: { provider: cdnProviderRuntime$WwPw9dOyBBJoAixmmH22q7hek9XFBqttHhtjTDBrtEA, defaults: undefined },
  ['ipx']: { provider: ipxRuntime$Yz6t6EezgLS0JjMNhtjX4WxsaC7Phwcm_eR5R3bdJEI, defaults: {} }
}
        